import(/* webpackMode: "eager" */ "/vercel/path0/src/app/domainFinder/page.tsx");
